<template>
  <div class="featured-store" :class="image_alignment">
    <div class="image">
      <img :src="require(`../../assets/images/home/${this.image}.jpg`)" />
    </div>
    <div class="store-container">
      <div class="store-image">
        <img
          :src="require(`../../assets/images/home/${this.store_image}.jpg`)"
        />
      </div>
      <div class="info">
        <span>available at</span>
        <span>46° 50’ 58.1676’’ N | 9° 31’ 50.412’’ E</span>
      </div>
    </div>
    <div class="btn-and-name">
      <h3 class="text-gradient" :class="color">Maison<br />Gassmann</h3>
      <a class="button transparent" :class="color">Link</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "featured-store",
  props: {
    image: String,
    store_image: String,
    color: String,
    store: String,
    image_alignment: String
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";

.featured-store {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  background-color: $brand-black;

  &.right {
    flex-direction: row-reverse;
  }

  .image {
    width: 100%;

    @media (min-width: $breakpoint-sm) {
      width: 50%;
    }

    img {
      width: 100%;
    }
  }

  .store-image {
    width: 50%;

    img {
      width: 100%;
      border-radius: 1rem;
    }
  }

  .store-container {
    display: none;

    @media (min-width: $breakpoint-sm) {
      width: 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .info {
        display: flex;
        flex-direction: column;
        color: $brand-white;
        margin-top: 1rem;
        text-align: center;

        span {
          font-weight: 700;
        }

        span:last-of-type {
          font-family: "Lora";
          margin-top: 1rem;
          padding: 0 1.5rem;
        }
      }
    }
  }

  .btn-and-name {
    position: absolute;
    left: 0;
    right: 0;
    align-items: center;
    display: flex;
    justify-content: center;
    flex-direction: column;

    h3 {
      text-align: center;
      font-size: $font-xxxl;
      margin-bottom: 1rem;
    }
  }
}
</style>
